module.exports = __webpack_public_path__ + "static/media/avalanche.553d1c76.png";